import { useState, useEffect } from 'react';
import { AdminService } from '../../../../core/services/AdminService';


interface Props {
    idSelector: number;
    onChange: any;

}

export const SelectorBusinessLogicTypeConstants = ({ idSelector, onChange }: Props) => {

    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getBusinessLogicTypeConstants().subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
               //console.log("DataAcces", lista);
            }
        );
    }

    return (
        <>
            <label className='mb-2'>Tipo</label>
            <select className="form-control" value={idSelector ?? undefined} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <>
                                <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}
